import Service from './service.js';

export class ComplaintV2 extends Service {
    constructor(quickComplaint, reasons) {
        super('#form-service-complaint', 'complaint');

        this.reasons = reasons;
        this.quickComplaint = quickComplaint;

        this.product = document.querySelector('#complaint-product');
        this.reason = document.querySelector('#complaint-reason');
        this.reklFreitext = document.querySelector('#complaint-note');
        this.deliverystart = document.querySelector('[name="Complaint[deliverystart]"]');
        this.deliveryend = document.querySelector('[name="Complaint[deliveryend]"]');
        this.hints = document.querySelectorAll('.hint');
        this.note =  document.querySelector('.field-complaint-note');

        this.normalComplaintButton = document.querySelector('.normalComplaintButton');
        
        this.initService();
    };

    initService() {
        this.reason.addEventListener('change', event => {
            let reason = event.currentTarget.value;
            let hint = document.querySelector('.reason-' + reason);
            
            this.hints.forEach(node => {
                node.classList.add('d-none');
            })

            if(hint) {
                hint.classList.remove('d-none');
            }
            
            this.checkRefundBox(reason);
            if(OVS.app.helper.isMhn) {
                this.toggleComment(reason);
            }
        });

        this.product.addEventListener('change', event => {
            let reason = event.currentTarget.options[event.currentTarget.selectedIndex].dataset.reason;
            var options = [];
            if (reason) {
                Object.entries(this.reasons[reason]).forEach(entry => {
                    const [key, value] = entry;
                    options.push({
                        text: value,
                        value: key
                    });
                });
                OVS.app.helper.updateSelect(this.reason, options);
            }
        });

        if (this.normalComplaintButton) {
            this.normalComplaintButton.addEventListener('click', event => {
                event.preventDefault();
                OVS.app.helper.addClass('.quickComplaint', 'd-none');
                OVS.app.helper.removeClass('.normalComplaint', 'd-none');
            });
        }

        if (this.quickComplaint) {
            this.product.selectedIndex = 1;
            this.reason.value = 'AGF';
            this.reason.dispatchEvent(new Event('change'));
        }
        
        if (this.product.options.length == 2) {
            OVS.app.helper.createSingleSelect(this.product);
        }
    };
    
    checkRefundBox(reason) {
        let refundBox = document.querySelector('.refundBox');
        if( refundBox) {
            if( (reason == 'AGF' ||reason == 'FZF') ) {
                refundBox.classList.remove('d-none');
            }
        }
    };
    
    toggleComment(reason) {
        let reasons = ['AGF', 'FAL', 'FZF'];
        if(reasons.includes(reason)) {
            this.note.classList.add('d-none');
            this.note.classList.remove('d-flex');
            this.reklFreitext.value = '';
        } else {
            this.note.classList.remove('d-none');
            this.note.classList.add('d-flex');
        }
    };
};
